export default __webpack_public_path__ + "static/media/01.133bf250.jpg";